// extracted by mini-css-extract-plugin
module.exports = {"allLetters":"allLetters_allLetters__21ccs"};